import {dbOperation} from './database';

// Email service for handling contact form submissions
export const sendContactEmail = async (formData) => {
  try {
    // Create the contact message record
    const newMessage = {
      id: Date.now().toString(),
      ...formData,
      timestamp: new Date().toISOString(),
      read: false
    };

    // Save to database
    const result = await dbOperation.saveContactMessage(newMessage);

    if (result.success) {
      // In production, you would also send actual email here
      // For now, we'll just log the email content
      const emailData = {
        to: 'info@aiximo.com',
        subject: `New Contact Form Submission from ${formData.fullName}`,
        html: generateEmailTemplate(formData),
        timestamp: new Date().toISOString()
      };

      console.log('Email would be sent:', emailData);
      return { success: true, messageId: newMessage.id };
    }

    throw new Error('Failed to save contact message');
  } catch (error) {
    console.error('Email sending failed:', error);
    return { success: false, error: error.message };
  }
};

const generateEmailTemplate = (formData) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .header { background: linear-gradient(135deg, #3b82f6, #8b5cf6); color: white; padding: 20px; text-align: center; }
        .content { padding: 20px; }
        .field { margin-bottom: 15px; }
        .label { font-weight: bold; color: #555; }
        .value { background: #f8f9fa; padding: 10px; border-left: 3px solid #3b82f6; margin-top: 5px; }
        .footer { background: #f8f9fa; padding: 15px; text-align: center; color: #666; font-size: 12px; }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>🚀 New Contact Form Submission</h1>
        <p>www.aiximo.com - AI-Powered Development Agency</p>
      </div>
      
      <div class="content">
        <h2>Contact Details</h2>
        
        <div class="field">
          <div class="label">Full Name:</div>
          <div class="value">${formData.fullName}</div>
        </div>
        
        <div class="field">
          <div class="label">Email Address:</div>
          <div class="value"><a href="mailto:${formData.workEmail}">${formData.workEmail}</a></div>
        </div>
        
        ${formData.companyName ? `
        <div class="field">
          <div class="label">Company:</div>
          <div class="value">${formData.companyName}</div>
        </div>
        ` : ''}
        
        ${formData.phoneNumber ? `
        <div class="field">
          <div class="label">Phone Number:</div>
          <div class="value">${formData.phoneNumber}</div>
        </div>
        ` : ''}
        
        <div class="field">
          <div class="label">Project Type:</div>
          <div class="value">${formData.projectType}</div>
        </div>
        
        <div class="field">
          <div class="label">Project Description:</div>
          <div class="value">${formData.projectDescription}</div>
        </div>
        
        ${formData.hearAboutUs ? `
        <div class="field">
          <div class="label">How they heard about us:</div>
          <div class="value">${formData.hearAboutUs}</div>
        </div>
        ` : ''}
        
        <div class="field">
          <div class="label">Submitted:</div>
          <div class="value">${new Date().toLocaleString()}</div>
        </div>
      </div>
      
      <div class="footer">
        <p>This email was sent from the www.aiximo.com contact form.</p>
        <p>Reply directly to this email to respond to ${formData.fullName}.</p>
      </div>
    </body>
    </html>
  `;
};

// Load contact messages
export const getAllContactMessages = async () => {
  return await dbOperation.getAllContactMessages();
};

// Mark message as read
export const markMessageAsRead = async (messageId) => {
  const messages = await getAllContactMessages();
  const message = messages.find(m => m.id === messageId);
  
  if (message) {
    message.read = true;
    message.updated_at = new Date().toISOString();
    return await dbOperation.saveContactMessage(message);
  }
  
  return { success: false, error: 'Message not found' };
};

// Notification service for admin alerts
export const sendAdminNotification = async (type, data) => {
  try {
    const notification = {
      id: Date.now().toString(),
      type,
      data,
      timestamp: new Date().toISOString(),
      read: false
    };

    // In production, this would integrate with your notification service
    console.log('Admin notification:', notification);
    
    return { success: true, notificationId: notification.id };
  } catch (error) {
    console.error('Notification failed:', error);
    return { success: false, error: error.message };
  }
};